module.exports = __webpack_public_path__ + "static/media/coming_soon.8c7c72df.gif";